import { createStore } from "vuex";
import goods from "./modules/goods";

const store = createStore({
  modules: {
    goods,
  },
});

export default store;
